import React from 'react'
import VisDiv from './frontend_components/VisDiv'
import { useStateContext } from '../context/StateContext';
import { urlFor } from '../lib/client';

const CustomerLogo = () => {
    const {customer} = useStateContext();

    const testing = false
    const testFunction = () => {
        console.log(customer)
    }
    const testButton =  <VisDiv rules={[testing]}><button onClick={testFunction}>test</button></VisDiv>

    const defaultLogo =  <img src="/assets/logo192.png" alt="logo" className='logo-image'/>

    const logoAppWidth = customer?.logoAppSize?.width
    const logoAppHeight = customer?.logoAppSize?.height
    //const url = urlFor(customer?.logoApp && customer?.logoApp).width(1020).height(1020)?.url()
    //const logoAppUrl = customer?.logoApp && urlFor(customer?.logoApp && customer?.logoApp).width(logoAppWidth).height(logoAppHeight)?.url()
    const logoAppUrl = customer?.logoApp && urlFor(customer?.logoApp && customer?.logoApp)?.url()
    const logoApp =  <img layout="fill" style={{width:`${logoAppWidth}px`, height:`${logoAppHeight}px`}} src={logoAppUrl && logoAppUrl} alt="logo"/>

    const logoHeaderWidth = customer?.logoHeaderSize?.width
    const logoHeaderHeight = customer?.logoHeaderSize?.height
    //const logoHeaderUrl = customer?.logoHeader && urlFor(customer?.logoHeader && customer?.logoHeader).width(logoHeaderWidth).height(logoHeaderHeight)?.url()

    const logoHeaderUrl = customer?.logoHeader && urlFor(customer?.logoHeader && customer?.logoHeader)?.url()
    const logoHeader =  <img layout="fill" style={{width:`${logoHeaderWidth}px`, height:`${logoHeaderHeight}px`}} src={logoHeaderUrl && logoHeaderUrl} alt="logo"/>

  if(customer?.logoApp) return (
    <>
    {testButton}
    {logoApp}
  </>
  )  
  if(customer?.logoHeader) return (
    <>
    {logoHeader}
  </>
  ) 
  
  return (
    <>
      {defaultLogo}
    </>
  
  )
}

export default CustomerLogo
